
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36.01 25.85"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M26.88 25.85H9.17a13.27 13.27 0 012.13-7.29 9 9 0 013-2.93 7 7 0 017.2-.13c3.72 1.96 5.55 6.73 5.38 10.35zM24.51 6.48A6.46 6.46 0 1118.11 0a6.45 6.45 0 016.4 6.48zm5.26 8.06A4.57 4.57 0 1134.34 10a4.57 4.57 0 01-4.57 4.55zM10.89 10a4.56 4.56 0 11-1.34-3.27A4.55 4.55 0 0110.89 10zm-.4 7.74a14.43 14.43 0 00-2.33 6H0c.14-.87.18-1.71.39-2.52a7.4 7.4 0 013.39-4.75 5.24 5.24 0 016.71 1.24zm25.47 6h-8a14.41 14.41 0 00-2.32-6 5.22 5.22 0 017.83-.43A8.41 8.41 0 0136 23.43a2.5 2.5 0 010 .29z","fill":"#c6d4dc","data-name":"Layer 1"}})])])
          )
        }
      }
    